import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { iClientReviews, IClientView, IClientViewHeader, IInitialState, ILocationResponse, IPProfessionCategories, IUserInfo } from './types'
import { reducers } from './reducers'
import { getAppointmentHistoryByClientThunk, getCheckAddressThunk, getClientExcelFileThunk, getClientsLabelsThunk, getClientsThunk, getClientViewHeaderThunk, getClientViewReviewsThunk, getClientViewThunk, getIndustryThunk, getProfessionCategoriesThunk, getLocationThunk, getProfileAnalyticsThunk, getRateAppThunk, getServiceAdvancedSettingsThunk, getServiceBrandGetThunk, getSocialProfileThunk, getStoriesThunk, getUserCurrencyThunk, getUserEmailThunk, getUserInfoWebsiteThunk, getUserViewThunk } from './asyncthunk'
import { RootState } from '../../Store'


const initialState: IInitialState = {
    workDays: [],
    loading: false,
    error: null,
    locationCode: null,
    profileStatus: null,
    clients: [],
    clientId: null,
    profileAnalyticsList: [],
    userPerformance: {
        clients_count: 0,
        record_percentage: ''
    },
    dateBirthDay: null,
    instagramView: {
        instagram_username: "",
        image_url: ""
    },
    user: {
        id: 0,
        user: {
            id: 0,
            email: '',
            first_name: '',
            last_name: '',
            image_url: ''
        },
        phone_number: '',
        city: '',
        address: ''
    },
    clientView: {
        id: 0,
        image_url: '',
        name: '',
        instagram_username: '',
        instagram_image: '',
        phone_number: '',
        email: '',
        birthday: '',
        country: '',
        family_status: '',
        hobbies: '',
        about_service_notes: '',
        other_notes: '',
        label: { id: 0, name: '', color: '' }
    },
    clientViewHeader: {
        total_price: null,
        appointment_count: null,
        average_rating: null
    },
    clientReviews: [],
    email: 'test',
    userCurrency: '',
    website: null,
    servicesImages: [],
    brandsImages: [],
    serviceAdvancedSettings: {},
    oldImagesId: [],
    excelLink: '',
    rateApp: null,
    socialProfile: {
        instagram: null,
        whatsapp: null
    },
    stories: null,
    checkAddress: undefined,
    history: [],
    clientLabels: [],
    industryData: null as { industry: string } | null,
    professionCategories: [] as IPProfessionCategories[]
}



const ProfileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: reducers,
    extraReducers: (builder) => {
        builder
            .addCase(getClientsThunk.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                getClientsThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.clients = action.payload
                    state.loading = false;
                },
            )
            .addCase(
                getClientsThunk.rejected,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.error = action.payload;
                },
            )
            .addCase(
                getClientsLabelsThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.clientLabels = action.payload

                },
            )
            .addCase(getProfileAnalyticsThunk.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                getProfileAnalyticsThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.profileAnalyticsList = action.payload
                    state.loading = false;
                },
            )
            .addCase(
                getProfileAnalyticsThunk.rejected,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.error = action.payload;
                },
            )

            .addCase(
                getStoriesThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<any>) => {
                    state.stories = action.payload
                },
            )
            .addCase(
                getLocationThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<ILocationResponse | null>) => {
                    state.locationCode = action.payload
                },
            )
            .addCase(
                getUserViewThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<IUserInfo>) => {
                    state.user = action.payload
                },
            )
            .addCase(
                getSocialProfileThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<any>) => {
                    state.socialProfile = action.payload
                },
            )
            .addCase(
                getSocialProfileThunk.rejected,
                (state: IInitialState) => {
                    state.socialProfile = {
                        instagram: null,
                        whatsapp: null
                    }
                },
            )

            .addCase(
                getClientViewThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<IClientView>) => {
                    state.clientView = action.payload
                },
            )
            .addCase(
                getClientViewHeaderThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<IClientViewHeader>) => {
                    state.clientViewHeader = action.payload
                },
            )
            .addCase(
                getClientViewReviewsThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<iClientReviews[]>) => {
                    state.clientReviews = action.payload
                },
            )
            .addCase(
                getUserEmailThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<string>) => {
                    state.email = action.payload
                },
            )
            .addCase(
                getUserCurrencyThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<string>) => {
                    state.userCurrency = action.payload
                },
            )
            .addCase(
                getUserInfoWebsiteThunk.fulfilled,
                (state: IInitialState, action: PayloadAction<string>) => {
                    state.website = action.payload
                },
            )
            .addCase(
                getServiceAdvancedSettingsThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.serviceAdvancedSettings = action.payload
                    state.servicesImages = action.payload.service_images
                }
            )
            .addCase(
                getServiceBrandGetThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.brandsImages = action.payload.brand_images
                }
            )
            .addCase(
                getClientExcelFileThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.excelLink = action.payload
                }
            )
            // .addCase(
            //     getServiceExcelFile.fulfilled,
            //     (state, action: PayloadAction<any>) => {
            //         state.excelLink = action.payload
            //     }
            // )
            .addCase(
                getRateAppThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.rateApp = action.payload
                }
            )
            .addCase(
                getCheckAddressThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.checkAddress = action.payload
                }
            )
            .addCase(
                getAppointmentHistoryByClientThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.history = action.payload
                }
            )
            .addCase(
                getIndustryThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.industryData = action.payload
                }
            )
            .addCase(
                getProfessionCategoriesThunk.fulfilled,
                (state, action: PayloadAction<IPProfessionCategories[]>) => {
                    state.professionCategories = action.payload
                }
            )

    }

})

export const { setClientId, setDateBirthDay, setBrandsImages, setServicesImages, setDeleteBrandsImages, setDeleteServicesImages,
    setCleanBrandsImages, setCleanServicesImages, setOldImagesId, setCleanOldImagesId, setDeleteServicesImagesById,
    setServiceAdvancedSettingsClean, setCleanClientView, setUpdateInstagramView, setUpdateSocialProfileView, setUpdateCheckAddress,
    setProfileStatus, setHistory
} = ProfileSlice.actions

export const selectWorkDays = (state: any) => state.profileReducer.workDays
export const selectClients = (state: any) => state.profileReducer.clients
export const selectClientId = (state: any) => state.profileReducer.clientId
export const selectProfileAnalytics = (state: any) => state.profileReducer.profileAnalyticsList
export const selectUserPerformance = (state: any) => state.profileReducer.userPerformance
export const selectUser = (state: RootState) => state.profileReducer.user
export const selectDateBirthDay = (state: any) => state.profileReducer.dateBirthDay
export const selectInstagramView = (state: any) => state.profileReducer.instagramView
export const selectClientView = (state: any) => state.profileReducer.clientView
export const selectClientViewHeader = (state: any) => state.profileReducer.clientViewHeader
export const selectClientReviews = (state: any) => state.profileReducer.clientReviews
export const selectEmail = (state: any) => state.profileReducer.email
export const selectUserCurrency = (state: any) => state.profileReducer.userCurrency
export const selectWebsite = (state: any) => state.profileReducer.website
export const selectServicesImages = (state: any) => state.profileReducer.servicesImages
export const selectBrandsImages = (state: any) => state.profileReducer.brandsImages
export const selectServiceAdvancedSettings = (state: any) => state.profileReducer.serviceAdvancedSettings
export const selectOldImagesId = (state: any) => state.profileReducer.oldImagesId
export const selectExcelLink = (state: any) => state.profileReducer.excelLink
export const selectRateApp = (state: any) => state.profileReducer.rateApp
export const selectSocialProfile = (state: any) => state.profileReducer.socialProfile
export const selectStories = (state: any) => state.profileReducer.stories
export const selectLocationCode = (state: any) => state.profileReducer.locationCode
export const selectCheckAddress = (state: any) => state.profileReducer.checkAddress
export const selectProfileStatus = (state: RootState) => state.profileReducer.profileStatus
export const selectIndustryData = (state: any) => state.profileReducer.industryData
export const selectHistory = (state: any) => state.profileReducer.history
export const selectClientLabels = (state: any) => state.profileReducer.clientLabels
export const selectProfessionCategories = (state: any) => state.profileReducer.professionCategories
export default ProfileSlice.reducer